import React from 'react';
import { connect } from 'react-redux';

//Components
import SmartMenu from '../index';
import WpBadge from 'Wpds/components/badge/WpBadge';
import { SmartLinkLogo } from '../../components';
import { WpButton } from 'Wpds/components/button';

//Selectors
import { getSalesForceSignUpUrl } from 'Shared/selectors/smartLinks';

//Logos
import salesForceLogo from '../../SalesForceLink/SalesForceLogo.png';

//Styles
import '../SmartMenu.scss';

//Helpers
import { trackClickedConnectApp } from 'Shared/tracking/tracking';
import { DataSourceSlugs } from 'Shared/constants/types';

const SalesForceSmartMenu = props => {
  const { hasSalesForceIntegration, salesForceSignUpUrl } = props;

  const renderSmartLinkDetailForOpportunity = (opportunity, is_last) => {
    const badgeColor = !opportunity.current_stage.startsWith('Closed')
      ? 'blue'
      : opportunity.current_stage.includes('Won')
      ? 'green'
      : 'gray';
    return (
      <>
        {opportunity.name && <div>Name: {opportunity.name}</div>}
        <div>
          Status:{' '}
          <WpBadge color={badgeColor} size="md">
            {opportunity.current_stage}
          </WpBadge>
        </div>
        <div>Close date: {opportunity.close_date}</div>
        {!is_last && <p />}
      </>
    );
  };

  const renderSmartLinkDetail = smart_link_detail => {
    const { subtype, opportunities } = smart_link_detail;
    return (
      <>
        {subtype == 'account' && (
          <div>
            <strong>Opportunities: </strong>
            <p />
            {opportunities.map((op, idx) => renderSmartLinkDetailForOpportunity(op, idx === opportunities.length - 1))}
          </div>
        )}
        {subtype == 'opportunity' && renderSmartLinkDetailForOpportunity(smart_link_detail, true)}
        <p />
        <a href={smart_link_detail.url} target="blank" rel="noopener norefferer">
          View {subtype}
        </a>
      </>
    );
  };

  const renderSmartLinkBadge = smart_link_detail => {
    const { subtype, current_stage } = smart_link_detail;
    if (subtype != 'opportunity') return null;
    const badgeColor = !current_stage.startsWith('Closed') ? 'blue' : current_stage.includes('Won') ? 'green' : 'gray';
    return (
      <div>
        <WpBadge color={badgeColor} size="md">
          {current_stage}
        </WpBadge>
      </div>
    );
  };

  const handleConnectClick = () => {
    trackClickedConnectApp(DataSourceSlugs.salesforce);
    window.location.href = salesForceSignUpUrl;
  };

  const renderEmbedingContent = () => {
    const className = 'SmartMenu__content__button';
    return (
      <>
        <div className={className}>To see more details about this link, connect your Salesforce account.</div>
        <p />
        <div className={className}>
          <WpButton variant="tertiary" onClick={handleConnectClick} block>
            Connect Salesforce
          </WpButton>
        </div>
      </>
    );
  };

  const menuTitle = smart_link_detail => (
    <>
      <SmartLinkLogo src={salesForceLogo} /> {smart_link_detail.subtype == 'opportunity' && 'Opportunity'}
      {smart_link_detail.subtype == 'account' && 'Account'}
    </>
  );

  return (
    <SmartMenu
      hasDocumentIntegration={hasSalesForceIntegration}
      renderEmbedingContent={renderEmbedingContent}
      renderSmartLinkDetail={renderSmartLinkDetail}
      renderSmartLinkBadge={renderSmartLinkBadge}
      objectName="Salesforce object"
      menuTitle={menuTitle}
      {...props}
    />
  );
};

const mapStateToProps = state => ({
  hasSalesForceIntegration: state.organization?.hasSalesforceIntegration,
  salesForceSignUpUrl: getSalesForceSignUpUrl(state),
});

export default connect(mapStateToProps)(SalesForceSmartMenu);
